import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { serverUrl } from '../../constants'

// Define a service using a base URL and expected endpoints
export const serviceApi = createApi({
  reducerPath: 'serviceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: serverUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.value
      // console.log('token state', token)
      // If we have a token set in state, let's assume that we should be passing it.
      headers.set('authorization', `Bearer ${token}`)
      headers.set('Content-Type', `application/json`)
      if (token) {
        // window.localStorage.setItem('token', token)
      }
      return headers
    }
  }),
  tagTypes: ['Services'],
  endpoints: (builder) => ({
    fetchService: builder.query({
      query: (mId) => ({
        url: `services?mId=${mId}`,
      }),
      providesTags: ['Services'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFetchServiceQuery } = serviceApi